import { ExclamationMarkOutlineSVG } from '@svgComponents/exclamationMarkOutlineSVG/ExclamationMarkOutlineSVG';
import classNames from 'classnames';

import IwMedia from '../../../iwMedia';
import UploadButton from '../../ui/uploadButton/UploadButton';
import {
    MarkDoneButton,
    TFeedbackCategory
} from '../documentFeedback/MarkDoneButton';

export const FeedbackCard = ({
    children,
    isMarkedAsDone,
    isMarkingAsDone,
    warningText,
    instructionText,
    onMarkAsDone,
    uploadText,
    onUpload,
    feedbackCategory
}: {
    children: React.ReactNode;
    isMarkedAsDone: boolean;
    isMarkingAsDone: boolean;
    warningText: React.ReactNode;
    instructionText: React.ReactNode;
    onMarkAsDone: () => void;
    uploadText: React.ReactNode;
    onUpload: () => void;
    feedbackCategory: TFeedbackCategory;
}) => {
    return (
        <>
            <div className="mb-m flex flex-col justify-between gap-m min-sm:flex-row">
                <div
                    className={classNames({
                        'opacity-50': isMarkedAsDone
                    })}
                >
                    <div className="flex items-center gap-s">
                        <ExclamationMarkOutlineSVG className="min-h-l min-w-l" />
                        <span className="m-0 font-med">
                            <span className="text-error">{warningText}</span>{' '}
                            {instructionText}
                        </span>
                    </div>
                </div>
                <IwMedia from="medium">
                    <MarkDoneButton
                        isLoading={isMarkingAsDone}
                        isMarkedAsDone={isMarkedAsDone}
                        onClick={onMarkAsDone}
                        feedbackCategory={feedbackCategory}
                    />
                </IwMedia>
            </div>
            <div
                className={classNames({
                    'opacity-50': isMarkedAsDone
                })}
            >
                {children}
            </div>
            <IwMedia from="medium">
                <UploadButton
                    className="pointer-events-auto flex opacity-100"
                    onClick={onUpload}
                >
                    {uploadText}
                </UploadButton>
            </IwMedia>
        </>
    );
};
